export const SUBMIT_ROUTE = '/v2-lib-tms/route/submit';
export const RETRY_STOP = '/v2-lib-tms/stop/retry';
export const DELAY_STOP = '/v2-lib-tms/stop/delay';
export const CONFIRM_STOP = '/v2-lib-tms/stop/confirm';
export const BATCH_TIMEFRAME_CONFIRMATION = '/v2-lib-tms/route/batch-timeframe-confirmation';
export const CROSSDOCK_CONFIRM_TIMEFRAME_TEXT = 'v2-lib-tms/order/timeframe-confirmation';
export const GENERATE_CUSTOMER_TOKEN = '/v2-lib-customer/get-token/guest';
export const VERIFY_TOKEN = '/v2-lib-customer/verify-token';
export const INVITE_TEMP_DRIVER = '/v2-auth/inviteTempDriver';
export const INVITE_TEAMMATE = '/v2-auth/inviteTeammate';
export const CREATE_TEAMMATE = '/v2-auth/createTeammate';
export const CREATE_CLIENT = '/v2-auth/createClient';
export const CREATE_CORP_CLIENT = '/v2-auth/createCorpClient';
export const MATCH_CORP_CARRIERS = '/v2-auth/matchCorpCarriers';
export const ADD_CORP_CARRIERS = '/v2-auth/addCorpCarriers';
export const REVIEW_CONTRACTOR_COMPLIANCE = '/v2-auth/reviewContractorCompliance';
export const SET_CARRIER_INTEGRATIONS_REQUIRED = '/v2-auth/setCarrierIntegrationsRequired';
export const SET_SHIPPER_INTEGRATIONS_REQUIRED = '/v2-auth/setShipperIntegrationsRequired';
export const REINVITE_CARRIER = '/v2-auth/reinviteCarrier';
export const VALIDATE_EMAIL = '/v2-auth/validateEmail';
export const CREATE_CORPORATE_ADMIN = '/v2-auth/createCorporateAdmin';
export const RESET_ACCOUNT = '/v2-auth/resetAccount';
export const INVITE_PARTNER = '/v2-auth/invitePartner';
export const PRICING_LTL = '/v2-pricing/ltl-order-pricing';
export const GET_INSTANT_QUOTE = 'v2-pricing/instant-quote';
export const STRIPE_CREATE_CUSTOMER = '/v2-lib-stripe/createCustomer';
export const STRIPE_CREATE_PAYMENT = '/v2-lib-stripe/createPayment';
export const STRIPE_CREATE_SETUP_INTENT = '/v2-lib-stripe/createSetupIntent';
export const STRIPE_GET_CARD_DETAILS = '/v2-lib-stripe/getCardDetails';
export const REMOVE_CARD = '/v2-lib-stripe/removeCard';
export const CUSTOMER_SHIPMENT = '/v2-lib-customer/shipment/new';
export const CUSTOMER_SHIPMENT_TRACKING = '/v2-lib-customer/shipment/tracking';
export const CREATE_ORDER_JOB = '/v2-lib-jobs/init';
export const COMPUTE_ORDER_DISTANCE = '/v2-lib-jobs/distance';
export const ORDER_RECOMMENDATIONS = '/v2-api-recommendations/orders';
export const NOTIFY_CARRIERS_OF_LTL_ORDER = `/v2-api-communications/notify-carriers-ltl-orders`;
export const EMAIL_CUSTOMER_INVOICE = `/v2-lib-tms/email-customer-invoice`;
export const NOTIFY_CARRIER_OF_ADMIN_ASSIGNMENT = `/v2-api-communications/notify-carrier-on-admin-assignment`;
export const PREDELIVERY_SMS = `/v2-api-communications/predelivery-sms`;
export const CUSTOM_SMS = '/v2-api-communications/custom-sms';
export const INVITE_PARTNER_CARRIER = `/v2-auth/invite-partner-carrier`;
export const CREATE_LISTINGS = '/v2-api-marketplace/listings';
export const PLACE_BID = '/v2-api-marketplace/listings/place-bid';
export const SUBMIT_COUNTER = 'v2-api-marketplace/listings/submit-counter';
export const CLAIM_NOW = '/v2-api-marketplace/listings/claim-now';
export const ACCEPT_BID = '/v2-api-marketplace/listings/accept-bid';
export const CANCEL_LISTING = '/v2-api-marketplace/listings/cancel';
export const MAPBOX_OPTIMIZE = '/v2-lib-tms/route/optimize/mapbox';
export const PARSE_PDF = '/v2-lib-jobs/parse-pdf';
export const INTEGRATION_UPLOAD = '/v2-lib-integrations-endpoints/integration/upload';
export const PRICE_CUSTOMER_UPGRADES = '/v2-lib-customerShipment/upgrade';
export const MANUAL_DISPATCH_PARTNER_SUBMIT = '/v2-lib-sendOrdersToExternalDispatchClients';
export const EXCEPTIONS_EXPORT_CSV = '/v2-exports/exceptions';
export const ORDERS_EXPORT_CSV = '/v2-exports/orders';
export const MANUAL_DISPATCH_PARTNER_UPDATE = '/v2-lib-updateSingleDispatchIntegrationOrder';
export const RETRY_MESSAGES = '/v2-lib-messages/retry';
export const SCHEDULE_ORDER_CALL = '/v2-lib-tms/survey/voice/init';
export const RECALCULATE_DRIVER_PAY = '/v2-lib-tms/driver-payments/recalculate';
export const SEND_GIG_CANCELLATION_EMAIL = '/v2-api-communications/request-gig-cancellation';
export const RETRY_INTEGRATION = '/v2-lib-integrations-endpoints/integration/retry';
export const TRIGGER_ORDER_EVENT = '/v2-lib-integrations-endpoints/events/trigger';
export const UNASSIGN_CARRIER = '/v2-lib-integrations-endpoints/carrier/unassign';
export const REVERT_INVOICES_PREVIEW = '/v2-lib-integrations-endpoints/invoices/revert-preview';
export const REVERT_INVOICES = '/v2-lib-integrations-endpoints/invoices/revert';
export const UPLOAD_INTEGRATION_SECRET = '/v2-lib-integrations-endpoints/integrations/save';
export const TRACK_DRIVER = '/v2-lib-drivers/track';
export const SSO = '/v2-auth/sso';
export const SSO_EXCHANGE = '/v2-lib-customer/verify-token/user/sso';
